import { useMemo } from "react";
import SelectBoxSingle from "../selectbox-single";
import { ILoaiLienHeItem } from "./useLoaiLienHe";

interface ISelectBoxLoaiLienHeProps {
    loaiLienHes: ILoaiLienHeItem[];
    value?: number | null;
    onValueChanged: (id?: number) => void;
    placeholder?: string;
    disabled?: boolean;
    width?: string | number;
}

const SelectBoxLoaiLienHe = (props: ISelectBoxLoaiLienHeProps) => {
    const items = useMemo(
        () => props.loaiLienHes.map(x => ({ id: x.id, text: x.ten_loai })),
        [props.loaiLienHes]
    );

    return (
        <SelectBoxSingle
            items={items}
            value={props.value || undefined}
            onValueChanged={(v) => props.onValueChanged(v === undefined ? undefined : Number(v))}
            placeholder={props.placeholder ?? "Chọn loại liên hệ"}
            disabled={props.disabled}
            width={props.width}
        />
    );
};

export default SelectBoxLoaiLienHe;
